<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical :headerTitle="editingData.__created__ ? '고객지원 추가' : '고객지원 상세'" device="web">
        <template v-slot:body>
          <v-form ref="form">
            <v-row v-if="!editingData.__created__" no-gutters>
              <v-col cols="12" class="d-flex justify-space-between align-center sub-title">
                <div>
                  <span>
                    작성자 :
                    <span span class="font-weight-bold">{{ '\u00A0' + (editingData.reporterNm || '') }}</span>
                  </span>
                  <span style="margin-left: 70px;">
                    작성일 :
                    <span span class="font-weight-bold">{{ '\u00A0' + (editingData.createdAt || '') }}</span>
                  </span>
                  <span style="margin-left: 70px;">
                    처리상태 :
                    <span span class="font-weight-bold">{{ '\u00A0' + (getStatusNm || '') }}</span>
                  </span>
                  <span style="margin-left: 70px;">
                    처리일자 :
                    <span span class="font-weight-bold">{{ '\u00A0' + (editingData.solvedAt || '') }}</span>
                  </span>
                </div>
                <v-btn
                  v-if="mainData.status === 'STATUS_04' || mainData.status === 'STATUS_05'"
                  color="primary"
                  elevation="0"
                  small
                  class="rounded"
                  @click="requestReconfirm"
                  >재확인 요청</v-btn
                >
              </v-col>
            </v-row>
            <!-- 제목 -->
            <v-row no-gutters :class="{ 'mt-5': !editingData.__created__ }">
              <v-col md="9" lg="6" class="pr-2">
                <span class="editor-label required">제목</span>
                <v-text-field v-model="editingData.subject" solo class="editor_bg" :rules="rules" :disabled="!isMyContent"></v-text-field>
              </v-col>
              <v-col md="3" lg="3" class="pl-2">
                <span class="editor-label">수정요청일</span>
                <v-menu ref="menuStDate" v-model="reqDt" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="requestedDate"
                      v-model="editingData.requestedDate"
                      label="수정요청일"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      solo
                      class="editor_bg"
                      hide-details="auto"
                      spellcheck="false"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editingData.dispStDate"
                    no-title
                    scrollable
                    @input="reqDt = false"
                    @change="onValueChanged"
                    :disabled="!isMyContent"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="12" lg="9">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span>
                      <span class="editor-label">내용</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '발생한 문제에 대해 작성해주십시요.' }}</div>
                </v-tooltip>
                <v-textarea
                  ref="content"
                  v-model="editingData.content"
                  no-resize
                  solo
                  class="editor_bg"
                  auto-grow
                  :disabled="!isMyContent"
                  :placeholder="contentPlaceHolder"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="12" lg="9">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span>
                      <span class="editor-label">수정/추가 요청사항</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '문제에 해결을 위해 필요한 요청사항에 대해 작성해주십시요.' }}</div>
                </v-tooltip>
                <v-textarea
                  ref="contentReq"
                  v-model="editingData.contentReq"
                  no-resize
                  solo
                  class="editor_bg"
                  auto-grow
                  :disabled="!isMyContent"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="12" lg="9">
                <iFileManage ref="detailFileUpload" :targetId="targetId" targetType="00004" @onFileChanged="onFileChanged" />
              </v-col>
            </v-row>
            <v-row v-if="!editingData.__created__" no-gutters class="mt-5">
              <v-col md="12" lg="4">
                <span class="editor-label">처리상태</span>
                <v-select
                  v-model="editingData.status"
                  :items="bugReportStatusList"
                  item-text="minorNm"
                  item-value="minorCd"
                  solo
                  class="editor_bg"
                  :disabled="!isMasterGrp"
                >
                  <template v-slot:selection="{ item }">
                    <div class="text-center">{{ item.minorNm }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content @click="editingData.status = item.minorCd">
                      <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row v-if="!editingData.__created__" no-gutters class="mt-5">
              <v-col md="12" lg="9">
                <span class="editor-label">답변</span>
                <v-textarea
                  ref="replyContent"
                  v-model="editingData.replyContent"
                  no-resize
                  solo
                  class="editor_bg"
                  auto-grow
                  :readonly="!isMasterGrp"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </i-card-vertical>
      <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch(mainData)" @btnSave="btnSave()" @btnDelete="btnDelete()">
        <template v-slot:customBtn>
          <i-icon-button color="btn_text" :text="'목록으로'" height="92px" :icon="'back'" @click="btnCancel()" :appendDivider="true"></i-icon-button>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { getCurrentDate } from '@/utils/common.js'
import { getUserCd, getGrpAuthCd } from '@/utils/token'
import { getBugReportDetail, deleteBugReport, saveBugReport, requestBugReportReconfirm } from '@/api/customerSupport/customerSupport'
import { getCommonCode } from '@/api/common/commonApi'
import { getRefreshToken, setID, setToken } from '@/utils/token'

export default {
  mixins: [baseview], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    iFileManage,
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop
  },
  data() {
    return {
      rules: [
        value => {
          if (value) return true
          return '필수입력 값입니다.'
        }
      ],
      buttonUseList: [
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnDelete' // 삭제
      ],
      bugReportStatusList: [],
      mainData: {}, // 라우터 파라미터 데이터
      editingData: {}, // DOM 데이터
      params: {},
      fileList: {
        insert: [],
        delete: []
      },
      targetId: '',
      reqDt: false,
      contentPlaceHolder: `발생 메뉴: \n발생 시각: \n재현 방법:\n`
    }
  },
  watch: {},
  computed: {
    isMyContent() {
      // 로그인한 계정의 게시글만 수정 가능
      if (this.mainData?.__created__ || this.editingData?.__created__) return true
      return getUserCd() === this.editingData.createdBy
    },
    isMasterGrp() {
      // 마스터 그룹만 답변 수정 가능
      return getGrpAuthCd() === 'master'
    },
    getStatusNm() {
      let statusNm = this.bugReportStatusList.find(el => el.minorCd === this.mainData.status)
      statusNm ? (statusNm = statusNm.minorNm) : (statusNm = '')
      return statusNm
    }
  },
  created() {
    Promise.all([getCommonCode('CM012') /* 문제보고상태*/]).then(response => {
      // 문제보고상태[조회조건][0]
      this.bugReportStatusList = response[0].list
    })
  },
  beforeMount() {},
  mounted() {
    // console.log('## mounted')
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }

    if (!this.$route.params.data.__created__) {
      this.mainData = this.$route.params.data
      this.btnSearch(this.mainData)
    }
  },
  activated() {
    // console.log('activated', this.$route.params.data)
    //데이터 초기화
    this.initializeData()
    // 페이지 이동시
    // 추가, 다른 데이터 상세 정보 호출 시
    if (this.$route.params.data) {
      //추가
      if (this.$route.params.data.__created__) {
        this.mainData = {}
        this.editingData = {}
        this.editingData.content = _.cloneDeep(this.contentPlaceHolder)
        this.initializeData()
      } else {
        if (this.editingData.writeDt != this.$route.params.data.writeDt || this.editingData.docNo != this.$route.params.data.docNo) {
          this.mainData = this.$route.params.data
          this.btnSearch(this.mainData)
        } else if (this.editingData.updatedAt != this.$route.params.data.updatedAt) {
          this.mainData = this.$route.params.data
          this.btnSearch(this.mainData)
        }
      }
    }
  },
  methods: {
    initializeData() {
      if (this.$route.params.data) {
        this.editingData.__created__ = this.$route.params.data.__created__
        this.targetId = `${this.$route.params.data.clntId}_${this.$route.params.data.writeDt}_${this.$route.params.data.docNo}`
        if (this.$route.params.data.__created__) {
          this.targetId = ''
          this.editingData.writeDt = getCurrentDate().replaceAll('-', '')
        }
      }
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    async btnSearch(param) {
      this.targetId = `${param.clntId}_${param.writeDt}_${param.docNo}`
      return new Promise((resolve, reject) => {
        this.openLoading()

        getBugReportDetail({ clntId: param.clntId, writeDt: param.writeDt, docNo: param.docNo }, true)
          .then(res => {
            this.editingData = res
            this.editingData.createdAt = this.convertDateFormatYYYYMMDD(res.createdAt)
            this.editingData.solvedAt = this.convertDateFormatYYYYMMDD(res.solvedAt)
            this.$refs.detailFileUpload.btnSearch()
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    async btnSave() {
      const validate = this.$refs.form.validate()
      if (!validate) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
        return
      }
      console.log('## saveData ==> ', this.editingData)
      this.vToastifyPrompt(this.$t('doSaveData'), 'info', current => {
        this.openLoading()
        this.editingData.userCd = getUserCd()
        if(!this.editingData.clntId) {
          this.editingData.clntId = this.getClntId()
        }
        let saveSuccess = false
        // this.editingData.writeDt = getCurrentDate().replaceAll('-', '')
        saveBugReport(this.editingData, true)
          .then(res => {
            if (res.success) {
              //첨부파일 처리를 위한 flag
              saveSuccess = true
              //상세 조회
              //저장 후 조회는 작성자 clntId 로 조회
              if (this.mainData.clntId) {
                res.map.clntId = this.mainData.clntId
              }
              getBugReportDetail(res.map, true).then(res => {
                this.editingData = res
                this.editingData.createdAt = this.convertDateFormatYYYYMMDD(res.createdAt)
                this.editingData.solvedAt = this.convertDateFormatYYYYMMDD(res.solvedAt)
                this.mainData = this.editingData
              })
              //게시글 첫 추가 후 해당화면에서 수정할 시 데이터 바인딩
              this.targetId = res.map.targetId
              this.editingData.__created__ = false
              this.editingData.docNo = res.map.docNo
            }
          })
          .finally(() => {
            // 저장 성공시 첨부 파일처리 - 신규 문서 targetId 할당 받기 위해 finally로 위치 변경
            if (saveSuccess && (this.fileList.insert.length !== 0 || this.fileList.delete.length !== 0)) {
              this.$refs.detailFileUpload.btnSave(this.fileList)
              this.fileList = {
                insert: [],
                delete: []
              }
            }
            this.endLoading()
          })
      })
    },
    btnDelete() {
      if (this.mainData.createdBy) {
        console.log('## 삭제', this.mainData)
        if (this.mainData.createdBy !== getUserCd()) {
          this.vToastify(this.$t('본인의 글만 삭제할 수 있습니다.'), 'info')
          return
        }
        let param = {
          clntId: this.mainData.clntId,
          writeDt: this.mainData.writeDt,
          docNo: this.mainData.docNo
        }
        this.vToastifyPrompt(this.$t('doDeleteData'), 'info', current => {
          this.openLoading()
          //this.DataGrids[0].beginUpdate()
          deleteBugReport([param])
            .then(res => {
              this.endLoading()
              this.$refs.detailFileUpload.fileRemove(this.$refs.detailFileUpload.files)
              //            this.btnSearch()
            })
            .catch(e => {
              this.endLoading()
            })
            .finally(() => {
              this.$router.go(-1)
            })
        })
      }
    },
    async btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async current => {
        this.$router.go(-1)
        return
      })
    },
    requestReconfirm() {
      this.openLoading()
      this.mainData.status = 'STATUS_06'
      this.editingData.status = 'STATUS_06'
      requestBugReportReconfirm(this.editingData)
        .then(res => {})
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.btnSearch(this.mainData)
          this.vToastify(this.$t('재확인 요청이 완료되었습니다.'), 'info')
          this.endLoading()
        })
    },
    convertDateFormatYYYYMMDD(fullDatetime) {
      if (fullDatetime && fullDatetime.length > 10) {
        fullDatetime = fullDatetime
          .substring(0, 10)
          .replace('-', '.')
          .replace('-', '.')
      }

      return fullDatetime
    },
    onValueChanged(event) {
      this.reqDt = false
      this.editingData.requestedDate = event.replaceAll('-', '.')
      // 날짜 세팅
      // if (event.value != '') {
      //   const date = new Date(event.value)
      //   const year = date.getFullYear()
      //   const month = String(date.getMonth() + 1).padStart(2, '0')
      //   const day = String(date.getDate()).padStart(2, '0')
      //   const dateFormat = `${year}.${month}.${day}`
      //   this.editingData.requestedDate = dateFormat
      // }
    },
    onFileChanged(fileList) {
      console.log('######## fileList', fileList)
      this.fileList = fileList
    }
  }
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}

//
.header_name {
  margin-left: 2px;
  font-weight: bold;
  font-size: 0.75rem;
  color: #000;
}

.header_value {
  font-weight: bold;
  font-size: 0.75rem;
  color: #2196f3;
}

.fileInfo {
  display: contents;
}

.upload_icon {
  height: 30px !important;
  margin-top: 5px;
  margin-bottom: 5px;
}

.dx-master-detail-row .dx-row-focused .file_icon {
  color: #fff !important;
}
</style>
